import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { AddIcon, DeleteIcon, EditIcon } from "@chakra-ui/icons";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  Center,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Spinner,
  Tab,
  Table,
  TableCaption,
  TableContainer,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tag,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { Upload } from "antd";
import { deleteObject, ref } from "firebase/storage";
import { useCallback, useEffect, useRef, useState } from "react";
import { BsEye } from "react-icons/bs";
import { storage } from "../../../firebase";
import { DELETE_PRODUCT } from "../../../services/graphql/mutation/Product";

import { IProductAdmin } from "../../../services/graphql/Product";
import { PRODUCTS_ADMIN } from "../../../services/graphql/query/Product";
import { useUnauthorizedAction } from "../../../services/hooks/useUnauthorizedAction";
import { MessageError } from "../../../shared/MessageError";
import { MessageSuccess } from "../../../shared/MessageSuccess";
import { FormCreateProduct } from "./FormCreateProduct";

export const Products = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [dataProducts, setDataProductsActive] = useState<IProductAdmin[]>([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [productToDelete, setProductToDelete] = useState<
    { id: number; refImg: string } | undefined
  >();
  const [productToUpdate, setProductToUpdate] = useState<
    IProductAdmin | undefined
  >();
  const [dataProductsInactive, setDataProductsInactive] = useState<
    IProductAdmin[]
  >([]);
  const [dataProductsWithoutStock, setDataProductsWithoutStock] = useState<
    IProductAdmin[]
  >([]);
  const [formCreateVisible, setFormCreateVisible] = useState<boolean>(false);
  const [modalImgVisible, setModalImgVisible] = useState<boolean>(false);
  const [formUpdateVisible, setFormUpdateVisible] = useState<boolean>(false);
  const [loadingDeleteProduct, setLoadingDeleteProduct] =
    useState<boolean>(false);
  const [deleteProduct] = useMutation(DELETE_PRODUCT);
  const [urlImg, setUrlImg] = useState<string>("");
  const { Dragger } = Upload;
  const cancelRef = useRef<any>();
  const { fetchMore } = useQuery(PRODUCTS_ADMIN);
  const { action } = useUnauthorizedAction();
  const unauthorized = useCallback(() => {
    action();
  }, []);
  const toast = useToast();

  const products = () => {
    setLoading(true);
    fetchMore({})
      .then((dataProducts) => {
        const { data } = dataProducts;
        const { productsAdmin } = data;

        setDataProductsActive(() => productsAdmin);
        setDataProductsWithoutStock(() =>
          productsAdmin.filter((ele: any) => ele.stock === 0)
        );

        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    products();
  }, []);

  const onCloseWithCleanState = () => {
    setProductToDelete(undefined);
    onClose();
  };

  const onDeleteProduct = (param: { id: number; refImg: string }) => {
    const { id, refImg } = param;
    setLoadingDeleteProduct(true);
    deleteProduct({
      variables: {
        id: id,
      },
    })
      .then(async () => {
        toast({
          duration: 2500,
          position: "bottom",
          render: () =>
            MessageSuccess({
              title: "Bien hecho!",
              description: "Tu producto se ha eliminado exitosamente!.",
            }),
        });
        if (refImg) {
          await deleteObject(ref(storage, refImg)).catch((error) => {
            console.log(error);
          });
        }
        products();
      })
      .catch((error) => {
        if (error.message !== "Unauthorized") {
          toast({
            duration: 2500,
            position: "top",
            render: () =>
              MessageError(
                error.message
                  ? error.message
                  : "Ocurrió un error al eliminar su producto. Por favor intente nuevamente."
              ),
          });
        } else {
          unauthorized();
        }
      })
      .finally(() => {
        setLoadingDeleteProduct(false);
      });
  };

  return (
    <>
      {loading ? (
        <Center>
          <Spinner />
        </Center>
      ) : !formCreateVisible && !formUpdateVisible ? (
        <>
          <Flex flexDirection={"column"}>
            <Button
              onClick={() => {
                setFormCreateVisible(true);
              }}
              colorScheme={"teal"}
              w={{ base: "100%", sm: "200px" }}
              ml={{ base: "0", sm: "auto" }}
              mb={3}
            >
              <AddIcon mr={2} /> Agregar producto
            </Button>
            <Tabs isFitted variant="enclosed">
              <TabList mb="1em">
                <Tab>Todos los productos</Tab>
                <Tab>Productos sin stock</Tab>
              </TabList>
              <TabPanels>
                <TabPanel>
                  {dataProducts.length ? (
                    <>
                      <TableContainer>
                        <Table variant="striped" colorScheme="teal">
                          <TableCaption>Todos los productos</TableCaption>
                          <Thead>
                            <Tr>
                              <Th isNumeric>Numero catalogo</Th>
                              <Th>Nombre</Th>
                              <Th>Descripción</Th>
                              <Th isNumeric>Precio</Th>
                              <Th isNumeric>Stock</Th>
                              <Th>Brilla</Th>
                              <Th>Imagen</Th>
                              <Th>Op.</Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {dataProducts.map((product) => (
                              <Tr>
                                <Td isNumeric>{product.catalog_number}</Td>
                                <Td>{product.name}</Td>
                                <Td>{product.description}</Td>
                                <Td isNumeric>{product.price}</Td>
                                <Td isNumeric>{product.stock}</Td>
                                <Td>{product.shine ? "Si" : "No"}</Td>
                                <Td>
                                  {product.url_image ? (
                                    <Button
                                      onClick={() => {
                                        setUrlImg(
                                          product.url_image
                                            ? product.url_image
                                            : ""
                                        );
                                        setModalImgVisible(() => true);
                                      }}
                                    >
                                      <BsEye />
                                    </Button>
                                  ) : null}
                                </Td>
                                <Td>
                                  <Button
                                    onClick={() => {
                                      setProductToUpdate(product);
                                      setFormUpdateVisible(true);
                                    }}
                                  >
                                    <EditIcon />
                                  </Button>
                                  <Button
                                    ml={3}
                                    onClick={() => {
                                      setProductToDelete({
                                        id: product.id,
                                        refImg: product.ref_image
                                          ? product.ref_image
                                          : "",
                                      });
                                      onOpen();
                                    }}
                                  >
                                    <DeleteIcon />
                                  </Button>
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        </Table>
                      </TableContainer>
                    </>
                  ) : (
                    <>
                      <Center>
                        <>
                          <p>
                            <Tag>NO TIENES PRODUCTOS ACTIVOS &#128532;</Tag>
                          </p>
                        </>
                      </Center>
                    </>
                  )}
                </TabPanel>
                <TabPanel>
                  {dataProductsWithoutStock.length ? (
                    <>
                      <TableContainer>
                        <Table variant="striped" colorScheme="teal">
                          <TableCaption>Productos sin stock</TableCaption>
                          <Thead>
                            <Tr>
                              <Th isNumeric>Numero catalogo</Th>
                              <Th>Nombre</Th>
                              <Th>Descripción</Th>
                              <Th isNumeric>Precio</Th>
                              <Th isNumeric>Stock</Th>
                              <Th>Brilla</Th>
                              <Th>Imagen</Th>
                              <Th>Op.</Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {dataProductsWithoutStock.map((product) => (
                              <Tr>
                                <Td isNumeric>{product.catalog_number}</Td>
                                <Td>{product.name}</Td>
                                <Td>{product.description}</Td>
                                <Td isNumeric>{product.price}</Td>
                                <Td isNumeric>{product.stock}</Td>
                                <Td>{product.shine ? "Si" : "No"}</Td>
                                <Td>
                                  {product.url_image ? (
                                    <Button
                                      onClick={() => {
                                        setUrlImg(
                                          product.url_image
                                            ? product.url_image
                                            : ""
                                        );
                                        setModalImgVisible(() => true);
                                      }}
                                    >
                                      <BsEye />
                                    </Button>
                                  ) : null}
                                </Td>
                                <Td>
                                  <Button
                                    onClick={() => {
                                      setProductToUpdate(product);
                                      setFormUpdateVisible(true);
                                    }}
                                  >
                                    <EditIcon />
                                  </Button>
                                  <Button
                                    ml={3}
                                    onClick={() => {
                                      setProductToDelete({
                                        id: product.id,
                                        refImg: product.ref_image
                                          ? product.ref_image
                                          : "",
                                      });
                                      onOpen();
                                    }}
                                  >
                                    <DeleteIcon />
                                  </Button>
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        </Table>
                      </TableContainer>
                    </>
                  ) : (
                    <>
                      <Center>
                        <>
                          <p>
                            <Tag>NO TIENES PRODUCTOS SIN STOCK &#128532;</Tag>
                          </p>
                        </>
                      </Center>
                    </>
                  )}
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Flex>
        </>
      ) : formCreateVisible ? (
        <Center>
          <Box minW="200px" maxW={"500px"} w="100%">
            <FormCreateProduct
              onSuccess={() => {
                products();
                setFormCreateVisible(false);
              }}
            />
          </Box>
        </Center>
      ) : formUpdateVisible ? (
        <>
          <Center>
            <Box minW="200px" maxW={"500px"} w="100%">
              <FormCreateProduct
                editMode={true}
                productToUpdate={productToUpdate}
                onSuccess={() => {
                  products();
                  setFormUpdateVisible(false);
                }}
              />
            </Box>
          </Center>
        </>
      ) : null}
      <Modal
        onClose={() => {
          setModalImgVisible(false);
        }}
        isOpen={modalImgVisible}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            <Image src={urlImg} />
          </ModalBody>
        </ModalContent>
      </Modal>

      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={() => {
          onCloseWithCleanState();
        }}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Eliminar producto
            </AlertDialogHeader>

            <AlertDialogBody>
              ¿Seguro que desea eliminar el producto?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                ref={cancelRef}
                onClick={() => {
                  onCloseWithCleanState();
                }}
              >
                Cancelar
              </Button>
              <Button
                colorScheme="red"
                onClick={() => {
                  if (productToDelete) {
                    onDeleteProduct(productToDelete);
                  }
                  onCloseWithCleanState();
                }}
                ml={3}
              >
                Eliminar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};
